import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { MobileLocationSelection } from "./component";

import { IStoreState } from "../../../../reducers/types";
import {
  setAmenitiesFilter,
  setFreeCancelFilter,
  setHotelNameFilter,
  setLoyaltyProgramsFilter,
  setMaxPriceFilter,
  setPackagesHotelsAvailabilitySortOption,
  setPolicyFilter,
  setStarRatingsFilter,
} from "../../actions/actions";
import {
  getDepartureDate,
  getDestination,
  getOpenDatesModal,
  getReturnDate,
} from "../../../search/reducer";
import {
  getTravelWalletCredit,
  getTravelWalletOffers,
} from "../../../travel-wallet/reducer";
import { setOpenDatesModal } from "../../../search/actions/actions";

const mapStateToProps = (state: IStoreState) => {
  return {
    departureDate: getDepartureDate(state),
    returnDate: getReturnDate(state),
    destination: getDestination(state),
    walletItemCount: getTravelWalletCredit(state)
      ? getTravelWalletOffers(state).length + 1
      : getTravelWalletOffers(state).length,
    datesModalOpen: getOpenDatesModal(state),
  };
};

const mapDispatchToProps = {
  setStarRatingsFilter,
  setAmenitiesFilter,
  setMaxPriceFilter,
  setFreeCancelFilter,
  setHotelNameFilter,
  setPackagesHotelsAvailabilitySortOption,
  setPolicyFilter,
  setLoyaltyProgramsFilter,
  setOpenDatesModal,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileLocationSelectionConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileLocationSelection = withRouter(
  connector(MobileLocationSelection)
);
